import { useStore as useBaseStore, usePublish as useBasePublish } from 'react-event-storm';

import { createStore } from 'event-storm';

import defaultState from './defaultState';

import { Store } from './types';

const store = createStore(defaultState);

const useStore = () => useBaseStore<Store>(store);

const usePublish = () => useBasePublish(store);

export { usePublish, useStore, store };
